const PERSON_LOOKUP_DOC_CODES = ['00', '04', '07']

const PERSON_LOOKUP_LABEL_PATTERNS = ['FOTOCHECK', 'CE', 'CARNET DE EXTRANJER', 'C.E']

const ALPHA_NUMERIC_DOC_CODES = ['00', '04', '07']

const getDocTypeLabel = (tipoDocumentoId, docType = []) => {
  const doc = docType.find((item) => item.value === tipoDocumentoId)
  return String(doc?.label || doc?.nombreCorto || '').toUpperCase()
}

const matchesLabelPatterns = (label, patterns) =>
  patterns.some((pattern) => label.includes(pattern))

export const isDocTypeWithPersonLookupFlow = (tipoDocumentoId, docType = []) => {
  if (!tipoDocumentoId) return false
  if (PERSON_LOOKUP_DOC_CODES.includes(tipoDocumentoId)) return true
  const label = getDocTypeLabel(tipoDocumentoId, docType)
  return matchesLabelPatterns(label, PERSON_LOOKUP_LABEL_PATTERNS)
}

export const isDocTypeAlphaNumeric = (tipoDocumentoId, docType = []) => {
  if (!tipoDocumentoId) return false
  if (ALPHA_NUMERIC_DOC_CODES.includes(tipoDocumentoId)) return true
  const label = getDocTypeLabel(tipoDocumentoId, docType)
  return matchesLabelPatterns(label, PERSON_LOOKUP_LABEL_PATTERNS)
}

export const isDocTypeFlexibleLength = (tipoDocumentoId, docType = []) =>
  isDocTypeWithPersonLookupFlow(tipoDocumentoId, docType)
